import { render, staticRenderFns } from "./subAccountSetting.vue?vue&type=template&id=12a67830&"
import script from "./subAccountSetting.vue?vue&type=script&lang=js&"
export * from "./subAccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./subAccountSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports